import axios from '../config/axios';
import { notification } from 'antd';
import {getResponseHandler} from './commonService'
import md5 from 'md5'
const login = {
    getlogin : async (data = {}) => {
        try{
            const rowData = await axios.post('/authentication/login',{...data,password:md5(data?.password)})
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    }
}
export default login